module.exports = "/_next/static/images/og_homepage_image-ff0bb791ebb6c2fc55366163fe5dad01.png";